import React, { createContext, useContext, useState } from 'react';
import {   CreateServiceCategory, CreateServiceByAdmin, fetchServiceCategory, fetchAdditionalService, deleteServiceCategory, updateServiceCategory, CreateAdditionalService, deleteAdditionalService, updateAdditionalService, deleteServiceById, setFeaturedService,UpdateCouponStataus,DeleteCoupon } from '../../services/api';
import { createcoupon, CreateService, FetchService, fetchServicebyId, UpdateService, ApproveService, FetchServiceByPartner, FetchAdditionalByServiceID, addPackage, FetchPackageByPartner, FetchPackageById, FetchAllPackage, ApprovePackage, updatePackage, getallcoupon, getallcouponbypartner, getallcouponbyadmin, disputedetailsbyadmin, FetchProductByPartner, FetchAllProducts, FetchProductById } from '../../services/Partner/PartnerApi'

const ServiceContext = createContext();

export const ServiceProvider = ({ children }) => {
    const [serviceCategory, setCategory] = useState([]);
    const [additionalService, setAdditionalService] = useState([]);
    const [service, setService] = useState([]);
    const [partnerservice, setPartnerService] = useState([]);
    const [Updateservice, setUpdateService] = useState([]);
    const [branches, setbranches] = useState([]);
    const [servicePackage, setpackage] = useState([]);
    const [products, setProducts] = useState([]);
    // State for Edit Dialog
    const [editOpen, setEditOpen] = useState(false);
    const [editType, setEditType] = useState(); // 'brand' or 'model'
    const [currentEditData, setCurrentEditData] = useState(null);
    const [updated, setUpdated] = useState(null);
    const[Coupans,setCoupansData]=useState([]);
    const[PartnerCoupans,setPartnerCoupansData]=useState([]);
    const AddServiceCategory = async (cat,file) => {       
        const result = await CreateServiceCategory(cat,file);
        setCategory(result.data); 
    };
    const FetchServiceCategory = async() => {
        const response =await fetchServiceCategory();
        setCategory(response.data);
    };
    const AddAditionalService = async (cat) => {
        const result = await CreateAdditionalService(cat);
        setAdditionalService(result.data);
    };
    const FetchAdditionalService = async () => {
       
        const response = await fetchAdditionalService();
        setAdditionalService(response.data);
    };
    const UpdateServiceCategory = async (cat,id,file) => {
      
        const result = await updateServiceCategory(cat, id, file);
        setCategory(result.data);
    };
    const editServiceCategory = (bodytypeId) => {
        setEditType('category');
        setCurrentEditData(bodytypeId);
        setEditOpen(true);
    };
    const UpdateAdditionalService = async (cat) => {
     
        const result = await updateAdditionalService(cat);
        setAdditionalService(result.data);
    };
    const editAdditionalService = (bodytypeId) => {
        setEditType('additionalservice');
        setCurrentEditData(bodytypeId);
        setEditOpen(true);
    };
    const DeleteServiceCategory = async (cat) => {
        const result = await deleteServiceCategory(cat)
        setCategory(result.data);
    };
    const DeleteAdditionalService = async (cat) => {
        const result = await deleteAdditionalService(cat)
        setAdditionalService(result.data);
    };

    const GetServices = async (cat) => {
       
        const result = await FetchService(cat)
        setService(result.data);
    };
    const GetPartnerServices = async () => {

        const result = await FetchServiceByPartner();
        setPartnerService(result.data);return result.data;
    };
    const GetAdditionalServices = async (id) => {

        const result = await FetchAdditionalByServiceID(id);
        setAdditionalService(result.data);
    };
    const AddService = async (cat,file) => {
       
        const result = await CreateService(cat,file)
        setService(result.data);
        return result.data;
    };

    const AddServiceByAdmin = async (cat, file) => {
        const result = await CreateServiceByAdmin(cat, file);
        return result.data;
    };

    const GetServiceByID = async (cat) => {
        const result = await fetchServicebyId(cat)
         
        setUpdateService(result.data);
    };

    const EditService = async (cat,file) => {       
        const result = await UpdateService(cat,file);
        setUpdateService(result.data); 
        return result.data;
    };
    const ApproveServiceById = async (id) => {    
        
        const result = await ApproveService(id);
        return result.data;
    };
    const ApprovePackageById = async (id) => {

        const result = await ApprovePackage(id);
        return result;
    };
    const SetServiceFeatured = async (id,isFeatured) => {

        const result = await setFeaturedService(id, isFeatured);
        setUpdateService(result.data);
      
        return result.data;
    };
    const AddPackage = async (p) => {

        const result = await addPackage(p);
        setpackage(result.data);
        return result.data;
    };
    const UpdatePackage = async (p) => {
        const result =await updatePackage(p);
        setpackage(result.data)
        return result.data;
    };
     const GetPackageByPartner = async (p) => {

        const result = await FetchPackageByPartner(p);
        setpackage(result.data)
    };
    const GetAllPackage = async (p) => {

        const result = await FetchAllPackage(p);
        setpackage(result.data)
    };
     const GetPackageById = async (id) => {

        const result = await FetchPackageById(id);
        return result.data;
    };
    const GetProductById = async (id) => {

        const result = await FetchProductById(id);
        return result.data;
    };
    const DeleteService = async (cat) => {
        const result = await deleteServiceById(cat)
        setService(result.data);
    };
    const AddCoupans= async (Coupan) =>{
        const result=await createcoupon(Coupan);
        return result;

    };
    const GetCoupansById= async (id) => {
        const result=await getallcoupon(id);
        return result;
    };
    const getallcouponpartner= async () =>{
        const result=await getallcouponbypartner();
        return result;
    }
    const getallcouponadmin= async () =>{
        const result=await getallcouponbyadmin();
        return result;
    }
    const disputeviewbyadmin=async() =>{
        const result=await disputedetailsbyadmin();
        return result;

    }
    const updateCouponStataus= async (id,status) => {
        const result=await UpdateCouponStataus(id,status);
        return result;
    };
      const deleteCoupon= async (id) => {
        const result=await DeleteCoupon(id);
        return result;
    };
    const GetProductByPartner = async (p) => {

        const result = await FetchProductByPartner(p);
        setProducts(result.data)
    };
    const GetAllProduct = async (p) => {

        const result = await FetchAllProducts(p);
        setProducts(result.data)
    };
    return (
        <ServiceContext.Provider value={{ setUpdateService, servicePackage, DeleteService, AddServiceCategory, FetchServiceCategory, AddAditionalService, FetchAdditionalService, serviceCategory, additionalService, UpdateServiceCategory, editServiceCategory, DeleteServiceCategory, DeleteAdditionalService, UpdateAdditionalService, editAdditionalService, editOpen, editType, currentEditData, setEditOpen, AddService, AddServiceByAdmin, GetServices, service, branches, Updateservice, GetServiceByID, EditService, ApproveServiceById, GetPartnerServices, partnerservice, GetAdditionalServices, AddPackage, GetPackageByPartner, GetPackageById, SetServiceFeatured, GetAllPackage, ApprovePackageById, UpdatePackage, AddCoupans, GetCoupansById, getallcouponpartner, getallcouponadmin, disputeviewbyadmin, updateCouponStataus, deleteCoupon, GetProductByPartner, GetAllProduct, products, GetProductById }}>
            {children}
        </ServiceContext.Provider>
    );
};

export const useServiceContext = () => useContext(ServiceContext);
